import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootswatch/dist/lux/bootstrap.min.css';
import { DEV_MODE } from './config';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  DEV_MODE ?
  <React.StrictMode>
    <App />
  </React.StrictMode> 
  : 
  <App />
);

if (DEV_MODE) {
  reportWebVitals();
}